import React from 'react';
import LoginPlaceholder from '../../pages/LoginPlaceholder';
import LoginPage from '../../pages/LoginPage';
import SignupPage from '../../pages/SignupPage';
import ForgotPasswordPage from '../../pages/ForgotPasswordPage';
import ForceChangePassword from '../../pages/ForceChangePassword';
import ProductReleasePage from '../../pages/ProductReleasePage';
import ConfirmForgotPasswordPage from '../../pages/ConfirmForgotPasswordPage';
import PrivacyPolicyPage from '../../pages/PrivacyPolicyPage';
import AccountDeletionPage from '../../pages/AccountDeletionPage';
import { NativeBaseProvider } from "native-base";
import { ToastProvider } from 'react-native-toast-notifications'
import { NavigationContainer } from '@react-navigation/native';
import CustomNavigationBar from '.././CustomNavigationBar'
import { nativeBaseTheme } from '../../theme'
import { useSelector } from 'react-redux';

import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getPlatform } from '../../utils/miscUtils'
import { Platform } from 'react-native';

const Stack = createNativeStackNavigator();

const linkingConfig = {
    config: {
        screens: {
            LoginPlaceholder: '/',
            Login: '/login',
            Signup: '/signup',
            ForgotPassword: '/forgot-password',
            ConfirmForgotPassword: '/confirm-forgot-password',
            ForceChangePassword: '/force-change-password',
            ProductRelease: '/product-release',
            PrivacyPolicy: '/privacy-policy',
            AccountDeletion: '/account-deletion',
        },
    },
};

const LoginStack = () => {
    const colorMode = useSelector((store) => store.settings.colorMode);
    const theme = nativeBaseTheme(colorMode);

    return <ToastProvider>
        <NativeBaseProvider theme={theme}>
            <React.Fragment>
                {
                    Platform.OS === "web" ? <style type="text/css">{`
                    @font-face {
                      font-family: 'MaterialCommunityIcons';
                      src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                    }
                  `}</style> : null
                }
                <NavigationContainer linking={linkingConfig}>
                    <Stack.Navigator screenOptions={{
                        header: (props) => <CustomNavigationBar {...props} />,
                    }}>
                        <Stack.Screen name="LoginPlaceholder" component={LoginPlaceholder} options={{ headerShown: false, title: "Loading", previous: false }} />
                        <Stack.Screen name="Login" component={LoginPage} options={{ headerShown: false, title: 'Login', previous: false }} />
                        <Stack.Screen name="Signup" component={SignupPage} options={{ headerShown: false, title: 'Sign Up', settings: false, previous: true }} />
                        <Stack.Screen name="ForgotPassword" component={ForgotPasswordPage} options={{ headerShown: false, title: 'Forgot Password', previous: true }} />
                        <Stack.Screen name="ConfirmForgotPassword" component={ConfirmForgotPasswordPage} options={{ headerShown: false, title: "Confirm Forgot Password", previous: true }} />
                        <Stack.Screen name="ForceChangePassword" component={ForceChangePassword} options={{ headerShown: false, title: "Change Password", previous: false }} />
                        {
                            getPlatform() === "web" ? <>
                                <Stack.Screen name="ProductRelease" component={ProductReleasePage} options={{ headerShown: false, title: "Product Releases", previous: true }} />
                                <Stack.Screen name="PrivacyPolicy" component={PrivacyPolicyPage} options={{ headerShown: false, title: "Privacy Policy", previous: true }} />
                                <Stack.Screen name="AccountDeletion" component={AccountDeletionPage} options={{ headerShown: false, title: "Account Deletion", previous: true }} />
                            </> : null
                        }
                    </Stack.Navigator>
                </NavigationContainer>
            </React.Fragment>
        </NativeBaseProvider>
    </ToastProvider>
}

export {
    LoginStack
}
